<div class="benefits-wrapper" *ngIf="promotedBenefits?.length"
     (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')">
    <div class="all-benefits">
        <div class="benefit" *ngFor="let promoted of promotedBenefits">
            <a title="" class="benfit-link" (click)="benefitClick(promoted)">
                <img *ngIf="promoted.discountImage?.url || promoted.type?.defaultImage?.url" [src]="promoted.discountImage?.url || promoted.type?.defaultImage?.url" [alt]="promoted.business?.name || promoted.businessGroup?.businessGroupName || promoted.discountImage?.alt || promoted.type?.defaultImage?.alt || ''" class="benefit-pic" />
                <div class="benefit-detail">
                    <h3>{{promoted.title}}</h3>
                    <span class="discount">{{promoted.discountPercent}}% הנחה במעמד החיוב </span>
                    <span class="adress" *ngIf="promoted.businessAddress">{{promoted.businessAddress}}</span>
                </div>
            </a>
        </div>
    </div>
</div>